<ng-content></ng-content>
<!--<div class="busy-indicator-wrapper" *ngIf="isShown">
	<div class="spinner"></div>
</div>-->
<div class="spinner-wrapper" *ngIf="busyIndicator && timeArrived">
	<div class="spinner"></div>
</div>
